var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.277 7.53h-5.895V3.75h.965c1.036 0 1.875-.839 1.875-1.875S41.382 0 40.347 0H7.656C6.621 0 5.781.839 5.781 1.875S6.621 3.75 7.656 3.75h.965v3.78H2.727C1.691 7.53.852 8.37.852 9.405v3.332a11.79 11.79 0 0 0 6.692 10.641l1.231.591c.78 5.497 4.477 10.068 9.469 12.091l-2.303 8.19H9.103c-1.036 0-1.875.839-1.875 1.875S8.068 48 9.103 48H38.9c1.036 0 1.875-.839 1.875-1.875s-.839-1.875-1.875-1.875h-6.836l-2.78-9.916c-.278-.992-1.304-1.574-2.298-1.303a11.04 11.04 0 0 1-2.985.397c-6.413 0-11.63-5.217-11.63-11.63V3.75h23.26v18.049a11.57 11.57 0 0 1-1.984 6.5c-.58.858-.354 2.024.504 2.603s2.024.354 2.603-.505a15.28 15.28 0 0 0 2.474-6.428l1.23-.591a11.79 11.79 0 0 0 6.692-10.641V9.405c0-1.036-.839-1.875-1.875-1.875zm-23.41 29.501a15.43 15.43 0 0 0 2.135.148c.74 0 1.445-.048 2.144-.148l2.024 7.22h-8.334l2.03-7.219zM4.602 12.737V11.28h4.02v8.428c-2.461-1.428-4.02-4.101-4.02-6.971zm38.8 0c0 2.871-1.559 5.543-4.02 6.971V11.28h4.02v1.457z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.635 13.735c0-1.036-.84-1.875-1.875-1.875h-3.519c-1.036 0-1.875.839-1.875 1.875 0 .997.778 1.812 1.759 1.871v4.379c-.982.06-1.759.875-1.759 1.872 0 1.035.839 1.875 1.875 1.875h3.519c1.035 0 1.875-.84 1.875-1.875 0-.997-.778-1.812-1.759-1.872v-4.379c.982-.06 1.759-.875 1.759-1.871z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 0.852,
    y1: 24.115,
    x2: 47.152,
    y2: 24.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6366f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d946ef"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.514485fcfc3c6074f6d6869e29006af9.svg";
export { ForwardRef as ReactComponent };